import React from "react";
import { Box, FormControl, FormErrorMessage, FormHelperText, FormLabel, Text, } from "@chakra-ui/react";
export { FormErrorMessage } from "@chakra-ui/react";
export function FormField({ isRequired = false, isOptional = false, label, badge, description, error, children, tip, ...props }) {
    return (React.createElement(FormControl, { isInvalid: Boolean(error), isRequired: isRequired, ...props },
        React.createElement(Box, null,
            React.createElement(FormLabel, { display: "inline" }, label),
            isOptional && (React.createElement(Text, { as: "span", size: "sm", color: "text.secondary", ml: 1 }, "(optional)")),
            React.createElement(Box, { as: "span", ml: 2 }, badge)),
        description && React.createElement(FormHelperText, null, description),
        React.createElement(Box, { mt: 2 }, children),
        error && React.createElement(FormErrorMessage, null, error),
        tip && (React.createElement(Text, { mt: 1, size: "sm", color: "text.tertiary" }, tip))));
}
